function truncateFileName(fileName) {
    const maxLength = 20; // Adjust the maximum length as needed
    if (fileName.length > maxLength) {
      return fileName.slice(0, maxLength - 4) + '...' + fileName.slice(-4);
    }
    return fileName;
  }

  export {truncateFileName};